import React from "react";
import { Row, Col, Radio } from "antd";
import styled from "styled-components";

interface IProps {
  question: string;
  options: string[];
  defaultValue: string;
  onChange: any;
}

export const QuestionRadio = (props: IProps) => {
  const { question, options, defaultValue, onChange } = props;
  return (
    <StyledRow gutter={16}>
      <QuestionCol span={12}>{question}</QuestionCol>
      <CenteredCol span={4}>
        <Radio value={options[0]} checked={defaultValue === options[0]} onClick={(e) => onChange(e)} />
      </CenteredCol>
      <CenteredCol span={4}>
        <Radio value={options[1]} checked={defaultValue === options[1]} onClick={(e) => onChange(e)} />
      </CenteredCol>
      <CenteredCol span={4}>
        <Radio value={options[2]} checked={defaultValue === options[2]} onClick={(e) => onChange(e)} />
      </CenteredCol>
    </StyledRow>
  );
};

const CenteredCol = styled(Col)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const QuestionCol = styled(Col)`
  @media (max-width: 767px) {
    font-size: 13px;
  }
`;

const StyledRow = styled(Row)`
  margin: 10px 0;
`;
